<template>
	<div class="publicity-content">
		<ul class="publicity-list">
			<li v-for="(item, index) in curData_" :key="item.id">
				<div class="publicity-img">
					<img src="../../../assets/img/lhc/zd-icon.png" />
				</div>
				<div class="publicity-title">{{item.title}}</div>
				<button class="btn-default" @click="goDetail(item.id)">查看详情</button>
				<div class="publicity-time">{{item.releaseTimestamp | time}}</div>
			</li>
		</ul>
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		data() {
			return {
				typeList: [{
					label: '制度规范',
					value: 'zdgf'
				}]
			}
		},
		methods: {
			goDetail(id) {
				this.$router.push({
					path: '/volunteerHome/institution/' + id
				})
			}
		}
	}
</script>

<style lang="scss">
	@import '~@/views/lch/css/publicity.scss';
</style>
